module.exports = __webpack_public_path__ + "static/media/SFCompactDisplay-Heavy.b7cbb309.ttf";